import { useState } from 'react';
import { useZakeke } from 'zakeke-configurator-react';
import { useEffect } from 'react';

const useLanguage = () => {
  const [language, setLanguage] = useState<string | null>(null);
  const { culture } = useZakeke();

  useEffect(() => {
    if (culture && culture !== language) {
      setLanguage(culture);
    }
  }, [culture, language]);

  return {
    language: language,
  };
};

export { useLanguage };
